module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/467.136dee82.png";